import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// @mui
import { Box, Drawer, Link, Stack, styled, useTheme } from '@mui/material';
import useNavData from 'src/hooks/useNavData';
import { PATH_PAGE } from 'src/routes/paths';
// config
import { NAV } from 'src/static/constants';

// components
import { NavSectionVertical } from '../../../components/nav-section';
import Scrollbar from '../../../components/scrollbar';
// hooks
import useResponsive from '../../../hooks/useResponsive';

import NavAccount from './NavAccount';
import NavGuide from './NavGuide';
import NavToggleButton from './NavToggleButton';
// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const { pathname } = useLocation();
  const navData = useNavData();
  const theme = useTheme();
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav(); // 조건을 만족할 때만 호출
    }
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
          // 상단과 하단 요소 사이 공간 분배
          justifyContent: 'space-between',
        },
      }}
    >
      <Stack spacing={3}>
        <Stack
          spacing={3}
          sx={{
            pt: 2,
            pb: 2,
            px: 2.5,
            flexShrink: 0,
          }}
        >
          {/* 로고 */}
          <Link
            component={RouterLink}
            to={PATH_PAGE.management.pr.news}
            sx={{ display: 'contents' }}
          >
            <LogoImage src={'/assets/images/icons/logo_w.png'} />
          </Link>
        </Stack>
        {/* 계정 */}
        <NavAccount />
        {/* nav */}
        <NavSectionVertical data={navData} />
      </Stack>

      {/* 가이드 배너 */}
      <NavGuide />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 0,
              width: NAV.W_DASHBOARD,
              bgcolor: 'transparent',
              borderRightStyle: 'dashed',
              backgroundColor: theme.palette.navBackgrounColor,
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
              backgroundColor: theme.palette.navBackgrounColor,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
      {isDesktop && <NavToggleButton />}
    </Box>
  );
}
const LogoImage = styled('img')(() => ({
  marginTop: '10px',
  width: '230px',
  height: 'auto',
}));
